import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminLayout from '@/components/Layout/AdminLayout';
import ChartPatternAuditSetup from './ChartPatternAuditSetup';
import ChartPatternAuditReview from './ChartPatternAuditReview';

const ChartPatternAudit = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const activeBatchId = useMemo(() => {
        const rawBatchId = searchParams.get('batchId');

        if (!rawBatchId) {
            return null;
        }

        const parsedBatchId = Number(rawBatchId);

        return Number.isInteger(parsedBatchId) && parsedBatchId > 0 ? parsedBatchId : null;
    }, [searchParams]);

    const handleStartReview = useCallback(
        (batchId: number) => {
            setSearchParams({ batchId: String(batchId) });
        },
        [setSearchParams]
    );

    const handleBackToSetup = useCallback(() => {
        setSearchParams({});
    }, [setSearchParams]);

    return (
        <AdminLayout containerSize={activeBatchId !== null ? '100%' : undefined} title="Chart Pattern Audit">
            {activeBatchId === null ? (
                <ChartPatternAuditSetup onStartReview={handleStartReview} />
            ) : (
                <ChartPatternAuditReview
                    batchId={activeBatchId}
                    key={activeBatchId}
                    onBack={handleBackToSetup}
                    onStartReview={handleStartReview}
                />
            )}
        </AdminLayout>
    );
};

export default ChartPatternAudit;
